'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { isEmpty, isEqual } from 'underscore';
import { connect } from 'react-redux';
import { DASHBOARD_DATE_FORMAT } from 'FormsUI/constants/DateFormats';
import { NON_HUBSPOT_FORM_LEARN_MORE } from 'FormsCommonComponents/constants/KCSArticlePaths';
import { getSubscriptionDefinitions as getSubscriptionDefinitionsFromAction } from 'FormsUI/actions/LegalConsent';
import { fetchForm as fetchFormFromAction } from 'FormsUI/actions/Form';
import { fetchCollectedFormIfNeeded, fetchSubscriptionsIfNeeded } from 'FormsUI/actions/CollectedForms';
import { updateParams as updateParamsAction } from 'FormsUI/actions/ReactRouter';
import { getCurrentForm } from 'FormsUI/selectors/Forms';
import { getCollectedForm, getRequestState, getSubscriptions } from 'FormsUI/selectors/CollectedForms';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import UICloseButton from 'UIComponents/button/UICloseButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UILink from 'UIComponents/link/UILink';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIBreakString from 'UIComponents/text/UIBreakString';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { InfoIcon } from 'foundations-assets';
import RequestState from 'FormsCommonComponents/lib/RequestState';
import DocLink from 'ui-forms-components/links/DocLink';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = suffix => `dashboard.table.collectedForms.sidePanel.${suffix}`;
class CollectedFormSidePanel extends PureComponent {
  constructor() {
    super();
    this.handleClose = this.handleClose.bind(this);
    this.handleOpenESP = this.handleOpenESP.bind(this);
  }
  componentDidMount() {
    const {
      guid,
      fetchForm,
      fetchCollectedForm,
      fetchSubscriptions,
      fetchSubscriptionDefinitions
    } = this.props;
    fetchForm(guid);
    fetchCollectedForm(guid);
    fetchSubscriptions(guid);
    fetchSubscriptionDefinitions(guid);
  }
  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.guid, this.props.guid)) {
      this.props.fetchForm(this.props.guid);
      this.props.fetchCollectedForm(this.props.guid);
      this.props.fetchSubscriptions(this.props.guid);
      this.props.fetchSubscriptionDefinitions(this.props.guid);
    }
  }
  handleClose() {
    const {
      updateParams,
      onClose
    } = this.props;
    updateParams({
      collectedFormsId: null
    });
    onClose();
  }
  handleOpenESP() {
    const {
      updateParams,
      guid
    } = this.props;
    updateParams({
      collectedFormsIdESP: guid
    });
  }
  maybeRenderMailChimpList() {
    const {
      subscriptions
    } = this.props;
    if (isEmpty(subscriptions)) {
      return null;
    }
    const espLink = /*#__PURE__*/_jsx(UILink, {
      onClick: this.handleOpenESP,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('mailchimp.link'),
        options: {
          count: subscriptions.filter(({
            syncEnabled
          }) => syncEnabled).length
        }
      })
    });
    return /*#__PURE__*/_jsx(UIPanelSection, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsxs("strong", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('mailchimp.header')
          }), /*#__PURE__*/_jsx(UITooltip, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: langKey('mailchimp.tooltip')
            }),
            children: /*#__PURE__*/_jsx(View, {
              as: "span",
              marginInlineStart: "200",
              children: /*#__PURE__*/_jsx(InfoIcon, {
                color: "do-not-use-eerie",
                size: "300"
              })
            })
          })]
        }), /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: langKey('mailchimp.lists'),
          options: {
            listCount: espLink
          }
        })]
      })
    });
  }
  renderName(name) {
    return /*#__PURE__*/_jsx(UIPanelSection, {
      children: /*#__PURE__*/_jsx(UIBreakString, {
        hyphenate: false,
        children: /*#__PURE__*/_jsx("strong", {
          children: name
        })
      })
    });
  }
  renderDate(date) {
    return /*#__PURE__*/_jsx(UIPanelSection, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('submissionDate')
          })
        }), /*#__PURE__*/_jsx(FormattedDateTime, {
          value: date,
          format: DASHBOARD_DATE_FORMAT,
          type: "portalTz"
        })]
      })
    });
  }
  renderInfoSection() {
    return /*#__PURE__*/_jsx(UIPanelSection, {
      children: /*#__PURE__*/_jsxs(UIAlert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('info.title')
        }),
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('info.body')
        }), /*#__PURE__*/_jsx(DocLink, {
          path: NON_HUBSPOT_FORM_LEARN_MORE,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('info.learnMore')
          })
        })]
      })
    });
  }
  renderAdvancedInfo(id, classes) {
    const identifiers = [...(id && [id]), ...(classes && [classes])];
    const maybeIdentifiers = !isEmpty(identifiers) ? /*#__PURE__*/_jsx("p", {
      children: identifiers.join(', ')
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('noIdentifiers')
    });
    return /*#__PURE__*/_jsx(UIPanelSection, {
      children: /*#__PURE__*/_jsx(UIAccordionItem, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('advancedInformation')
        }),
        size: "medium",
        children: /*#__PURE__*/_jsxs(UIFlex, {
          direction: "column",
          children: [/*#__PURE__*/_jsxs("strong", {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: langKey('identifiers')
            }), /*#__PURE__*/_jsx(UITooltip, {
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: langKey('identifiersTooltip')
              }),
              children: /*#__PURE__*/_jsx(View, {
                as: "span",
                marginInlineStart: "200",
                children: /*#__PURE__*/_jsx(InfoIcon, {
                  color: "do-not-use-eerie",
                  size: "300"
                })
              })
            })]
          }), /*#__PURE__*/_jsx(UIBreakString, {
            hyphenate: false,
            children: maybeIdentifiers
          })]
        })
      })
    });
  }
  renderContent() {
    const {
      form: {
        name
      },
      collectedForm: {
        createdAt,
        formSelectorId,
        formSelectorClasses
      }
    } = this.props;
    return /*#__PURE__*/_jsxs(UIPanel, {
      children: [/*#__PURE__*/_jsx(UICloseButton, {
        onClick: this.handleClose
      }), /*#__PURE__*/_jsx(UIPanelHeader, {
        children: /*#__PURE__*/_jsx("h2", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('header')
          })
        })
      }), /*#__PURE__*/_jsxs(UIPanelBody, {
        children: [this.renderName(name), this.renderDate(createdAt), this.maybeRenderMailChimpList(), this.renderInfoSection(), this.renderAdvancedInfo(formSelectorId, formSelectorClasses)]
      })]
    });
  }
  render() {
    const {
      requestState,
      form,
      collectedForm
    } = this.props;
    if (requestState.shouldShowAsLoading() || isEmpty(form) || isEmpty(collectedForm)) {
      return /*#__PURE__*/_jsx(UIPanel, {
        "data-test-id": "collected-form-side-panel",
        children: /*#__PURE__*/_jsx(UILoadingSpinner, {
          grow: true
        })
      });
    }
    return this.renderContent();
  }
}
CollectedFormSidePanel.propTypes = {
  fetchForm: PropTypes.func.isRequired,
  fetchCollectedForm: PropTypes.func.isRequired,
  fetchSubscriptions: PropTypes.func.isRequired,
  fetchSubscriptionDefinitions: PropTypes.func.isRequired,
  collectedForm: PropTypes.object,
  form: PropTypes.object,
  guid: PropTypes.string.isRequired,
  requestState: PropTypes.instanceOf(RequestState).isRequired,
  subscriptions: PropTypes.array,
  updateParams: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};
const mapStateToProps = (state, {
  guid
}) => ({
  form: getCurrentForm(state, guid),
  collectedForm: getCollectedForm(state, guid),
  requestState: getRequestState(state),
  subscriptions: getSubscriptions(state, guid)
});
const actionsToBind = {
  fetchForm: fetchFormFromAction,
  fetchCollectedForm: fetchCollectedFormIfNeeded,
  fetchSubscriptions: fetchSubscriptionsIfNeeded,
  fetchSubscriptionDefinitions: getSubscriptionDefinitionsFromAction,
  updateParams: updateParamsAction
};
export default connect(mapStateToProps, actionsToBind)(CollectedFormSidePanel);